import {Capacitor,registerPlugin} from '@capacitor/core';
const files=()=>registerPlugin<{save(options:{name:string;content:string}):Promise<{status:'saved'|'canceled'}>;dismissKeyboard():Promise<{dismissed:boolean}>}>('FinFlowFiles');
export async function dismissNativeKeyboard(){return Capacitor.getPlatform()==='android'?(await files().dismissKeyboard()).dismissed:false;}
export async function saveExport(content:string,name:string,format:'csv'|'json'):Promise<string>{
 if(Capacitor.isNativePlatform()){
  const result=await files().save({content,name});
  return result.status==='saved'?'File saved to your selected destination.':'Export canceled. No file was saved by FinFlow.';
 }
 const url=URL.createObjectURL(new Blob([content],{type:format==='csv'?'text/csv;charset=utf-8':'application/json'}));
 const a=document.createElement('a');a.href=url;a.download=name;document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
 return 'Download requested. Check your browser’s downloads before leaving.';
}
